"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("../Theme/constant");

var _constant2 = require("./constant");

var _default = {
  PropTypes: {
    carriers: _propTypes.default.arrayOf(_propTypes.default.shape({
      name: _propTypes.default.string,
      type: _propTypes.default.string,
      code: _propTypes.default.string,
      image: _propTypes.default.string
    })),
    size: _propTypes.default.string,
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    placeHolderBackground: _propTypes.default.string,
    customProperties: _propTypes.default.object
  },
  DefaultProps: {
    size: _constant2.SIZES.LARGE,
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    customProperties: {},
    carriers: []
  }
};
exports.default = _default;